module.exports = __webpack_public_path__ + "img/ncdc.da631c11.png";